// extracted by mini-css-extract-plugin
export default {"item":"Hero_item__TRT61"};